<template>
  <!-- Static sidebar for desktop -->
  <div class="hidden lg:flex lg:flex-shrink-0">
    <div
      class="flex flex-col duration-300 ease-linear"
      :class="{ 'w-16': hideBar, 'w-64': !hideBar }"
      @click="toggleSideBar"
    >
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex flex-col flex-grow pt-5 pb-4 overflow-y-auto bg-teal-700">
        <div
          class="flex flex-shrink-0 px-4 duration-500"
          :class="{ 'justify-between items-center': !hideBar }"
        >
          <Logo
            class="w-auto h-8 fill-current text-teal-50 duration-50"
            :class="{ hidden: hideBar }"
          />
          <MenuAlt1Icon class="w-6 h-6 text-teal-50 hover:cursor-pointer" />
          <!-- <img
            class="w-auto h-8"
            src="https://tailwindui.com/img/logos/easywire-logo-teal-300-mark-white-text.svg"
            alt="Easywire logo"
          /> -->
        </div>
        <menu-items :hide-label="hideBar" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, defineComponent, ref } from 'vue'
  import Logo from '/@/assets/logo.svg'
  import MenuItems from './MenuItems.vue'
  import { useCallStore } from '/@/store/callStore'
  import { useRecordStore } from '/@/store/recordStore'
  import { XIcon, MenuAlt1Icon, MenuAlt3Icon } from '@heroicons/vue/outline'
  const callStore = useCallStore()
  const recordStore = useRecordStore()
  const hideBar = ref(false)

  const toggleSideBar = () => {
    hideBar.value = !hideBar.value
  }
</script>
